export const routes = {
  home: '/',
  brand: '/brand',
  shop: '/shop',
  shopDetail: '/shop-detail',
  cart: '/cart',
  login: '/login',
  signup: '/signup',
};
